import * as React from 'react';
import { Shipment } from 'types/Watchlist';

interface Props {
  shipment: Shipment;
}

export const ShippingLine: React.FC<Props> = (props) => {
  const { shipment } = props;
  const { name, logo } = shipment.shippingLine;

  if (!logo) {
    return null;
  }

  return (
    <div>
      <img src={logo} alt={`logo ${name}`} className="max-h-10" />
    </div>
  );
};
ShippingLine.displayName = 'Shipments.DetailDrawer.Header.ShippingLine';
